import type { DatabricksCatalogTreeResponse } from '@protoss/shared';
import * as React from 'react';
import { dataCatalogApi } from '../services/dataCatalogApi';

export function useDataCatalogTree(projectUuid: string) {
  const [tree, setTree] = React.useState<DatabricksCatalogTreeResponse | null>(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  const load = React.useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await dataCatalogApi.getCatalogTree(projectUuid);
      setTree(data);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }, [projectUuid]);

  React.useEffect(() => {
    void load();
  }, [load]);

  return { tree, loading, error, reload: load };
}
